import * as React from 'react';

import * as styles from './styles.css';
import { useSelector } from 'react-redux';
import { selectFileUploadingProgress } from '../../selectors/form';

export const ProgressBar = () => {
  const percent = useSelector(selectFileUploadingProgress);

  return (
    <div className={styles.wrapper}>
      <div className={styles.bar} style={{ width: `${percent}%` }} />
    </div>
  );
};
